import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useRef, useState } from 'react';
import { TimetableDetailEntity } from 'src/entities/Timetable.entity';
import { useCreateTimetableMutation } from 'src/hooks/useTimetableMutations';
import { parseCourseMasterError } from 'src/utils/courseMasterError';

type Props = { open: boolean; onClose: () => void; onCreated: (timetable: TimetableDetailEntity) => void };

/** 新規ダイヤ（名前だけ。会社内で一意。所属コースは詳細で足す） */
export default function NewTimetableDialog({ open, onClose, onCreated }: Props) {
  const [name, setName] = useState('');
  const { enqueueSnackbar } = useSnackbar();
  const create = useCreateTimetableMutation();
  const inputRef = useRef<HTMLInputElement>(null);
  const submit = () =>
    create.mutate(
      { name: name.trim(), course_routes: [] },
      {
        onSuccess: (timetable) => {
          setName('');
          onCreated(timetable);
          enqueueSnackbar('ダイヤを追加しました', { variant: 'success' });
        },
        onError: (e) => enqueueSnackbar(parseCourseMasterError(e).message, { variant: 'error' }),
      },
    );
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      slotProps={{ transition: { onEntered: () => inputRef.current?.focus() } }}
    >
      <DialogTitle sx={{ fontSize: 16 }}>ダイヤを追加</DialogTitle>
      <DialogContent sx={{ pt: '12px !important' }}>
        <TextField
          label="ダイヤ名"
          size="small"
          fullWidth
          required
          inputRef={inputRef}
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => {
            // IME の変換確定の Enter（isComposing。Safari は keyCode 229）で送ると、変換途中の名前でダイヤができる
            if (e.nativeEvent.isComposing || e.keyCode === 229) return;
            if (e.key === 'Enter' && name.trim() && !create.isPending) submit();
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>キャンセル</Button>
        <Button variant="contained" disableElevation disabled={!name.trim() || create.isPending} onClick={submit}>
          追加する
        </Button>
      </DialogActions>
    </Dialog>
  );
}
